<template>
  <div class="performer-info-item">
    <div class="performer-info-item-inner--pc">
      <img class="performer-info-item--img" :src="performerImgSrc" :alt="name" />
      <h1 class="performer-info-item--name" :style="{color: textColor }">{{ name }}</h1>
      <div class="follow-wrapper">
        <button
          v-if="!followStatus"
          type="button"
          class="follow-btn"
          @click="onClick"
          :disabled="isSendingRequest"
        >
          フォローする
        </button>
        <button
          v-else type="button"
          class="follow-btn un-follow"
          @click="onClick"
          :disabled="isSendingRequest"
        >
          フォロー中
        </button>
      </div>
      <div class="description-wrapper">
        <p class="description" :style="{color: textColor }" v-html="description">
        </p>
      </div>
      <div class="sns-wrapper">
        <a
          class="facebook"
          :href="'https://www.facebook.com/sharer/sharer.php?u=' + url"
          data-app="facebook"
          target="_blank"
          rel="noopener"
          >
          <img :src="require('assets/images/curation/facebook.svg')"  width="7" height="15">
        </a>
        <a
          class="twitter"
          :href="'https://twitter.com/intent/tweet?url=' + url + '&text=' + text + '&via=tigetnet&hashtags=tiget&related=tigetnet'"
          data-app="twitter"
          :data-text="text"
          data-lang="ja"
          target="_blank"
          rel="noopener"
        >
          <img :src="require('assets/images/curation/twitter.svg')"  width="17" height="14">
        </a>
        <a
          class="line"
          :href="'https://social-plugins.line.me/lineit/share?url=' + url"
          data-app="line"
          target="_blank"
          rel="noopener"
        >
          <img :src="require('assets/images/curation/line.svg')"  width="22" height="8">
        </a>
      </div>
    </div>
    <div class="performer-info-item-inner--sp">
      <div class="img-btn-wrapper">
        <img class="performer-info-item--img" :src="performerImgSrc" :alt="name" />
        <div class="follow-wrapper">
          <button
            v-if="!followStatus"
            type="button"
            class="follow-btn"
            @click="onClick"
            :disabled="isSendingRequest">
            フォローする
          </button>
          <button
            v-else type="button"
            class="follow-btn un-follow"
            @click="onClick"
            :disabled="isSendingRequest">
            フォロー中
          </button>
        </div>
      </div>
      <div class="name-wrapper" @click="toggleDescription">
        <h2 class="performer-info-item--name" :style="{color: textColor }">{{ name }}</h2>
        <img class="toggle-btn" :class="{'open' : isOpenDescription}" :src="require('assets/images/curation/acc_arrow.svg')" width="12" height="6" alt="toggle">
      </div>
      <div v-if="isOpenDescription" class="description-wrapper">
        <p class="description" :style="{color: textColor }" v-html="description">
          {{ description }}
        </p>
      </div>
      <div v-if="isOpenDescription" class="sns-wrapper">
        <a
          class="facebook"
          :href="'https://www.facebook.com/sharer/sharer.php?u=' + url"
          data-app="facebook"
          target="_blank"
          rel="noopener"
          >
          <img :src="require('assets/images/curation/facebook.svg')"  width="7" height="15">
        </a>
        <a
          class="twitter"
          :href="'https://twitter.com/intent/tweet?url=' + url + '&text=' + text + '&via=tigetnet&hashtags=tiget&related=tigetnet'"
          data-app="twitter"
          :data-text="text"
          data-lang="ja"
          target="_blank"
          rel="noopener"
        >
          <img :src="require('assets/images/curation/twitter.svg')"  width="17" height="14">
        </a>
        <a
          class="line"
          :href="'https://social-plugins.line.me/lineit/share?url=' + url"
          data-app="line"
          target="_blank"
          rel="noopener"
        >
          <img :src="require('assets/images/curation/line.svg')"  width="22" height="8">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    performerId: {
      type: Number
    },
    performerImg: {
      type: String,
      default: require('assets/images/curation/no_image.svg')
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    followStatus: {
      type: Boolean,
      required: true
    },
    textColor: {
      type: String
    },
    rootUrl: {
      type: String
    }
  },
  data () {
    return {
      isOpenDescription: false,
      performerImgSrc: ''
    }
  },
  created () {
    this.performerImgSrc = this.performerImg ? this.performerImg : require('assets/images/curation/no_image.svg')
  },
  computed:{
    isSendingRequest: function () {
      return this.$store.getters['performer/isSendingRequest']
    },
    text: function () {
      return this.name + 'に関する情報はこちら'
    },
    url: function () {
      return this.rootUrl + 'performers/' + this.performerId + '/experimental_show'
    }
  },
  methods: {
    onClick: function () {
      this.$emit('followPerformer')
    },
    toggleDescription: function () {
      this.isOpenDescription = !this.isOpenDescription
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.performer-info-item {
  max-width: 240px;
  height: 100%;

  @media screen and (max-width: $breakpoint) {
    max-width: 100%;
  }
  &-inner--pc {
    position: sticky;
    top: 20px;

    @media screen and (max-width: $breakpoint) {
      display: none;
    }
  }
  &-inner--sp {
    display: none;
    @media screen and (max-width: $breakpoint) {
      display: block;
    }

    .img-btn-wrapper,
    .name-wrapper {
      display: flex;
      justify-content: space-between;
    }

    .img-btn-wrapper {
      margin-bottom: 15px;
    }

    .name-wrapper {
      margin-bottom: 10px;

      .toggle-btn {
        &.open {
          transform: rotate(180deg);
        }
      }
    }

    .sns-wrapper {
      margin-bottom: 30px;
    }
  }

  &--img {
    width: 240px;
    height: 240px;
    margin-bottom: 30px;
    border-radius: 20px;

    @media screen and (max-width: $breakpoint) {
      width: 70px;
      height: 70px;
      margin-bottom: 0;
      border-radius: 10px;
    }
  }

  &--name {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    width: 240px;
    margin-bottom: 30px;

    @media screen and (max-width: $breakpoint) {
      font-size: 16px;
      width: calc(100% - 30px);
      margin-bottom: 0;
    }
  }

  .follow-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    @media screen and (max-width: $breakpoint) {
      margin-bottom: 0;
      align-items: flex-end;
    }
    .follow-btn {
      border-radius: 15px;
      border: 1px solid #e6e6e6;
      color: #666;
      background-color: #fff;
      width: 120px;
      height: 30px;

      @media screen and (max-width: $breakpoint) {
        font-size: 12px;
        width: 110px;
        height: 26px;
      }
    }
  }

  .description-wrapper {
    padding-bottom: 20px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;

    .description {
      font-size: 13px;
    }
  }

  .sns-wrapper {
    display: flex;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 26px;
      border-radius: 3px;
      margin-right: 5px;
      background-color: #fff;
    }
  }
}
</style>
